// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"116":"53b4043f","240":"2472f45c","620":"e064ba03","625":"53b4043f","884":"25e1391e"}[chunkId] + ".css";
};